<template>
  <div>
    <div class="w-full h-full flex flex-col gap-5">
      <div class="flex items-center justify-between">
        <div class="flex flex-col md:flex-row justify-between w-full">
          <h1 class="text-xl font-semibold">
            Syllabus <span class="text-[16px]"> ({{ count_list || 0 }})</span>
          </h1>
          <div>
            <form
              @submit.prevent="searchUserValue"
              class="flex w-full md:w-auto"
            >
              <input
                type="text"
                name="search"
                id="search"
                v-model="search_list"
                @input="searchUserValue"
                placeholder="Type to Search"
                class="border-2 rounded-l-xl px-4 py-1.5 w-full md:w-[230px] outline-none"
              />
              <div class="flex justify-end items-center gap-3">
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                  "
                  class="px-4 py-2 text-sm md:py-2 rounded-r-xl"
                >
                  <img
                    src="@/assets/search.webp"
                    alt="Search"
                    class="w-6 h-6 object-contain"
                  />
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <div>
        <div class="w-full overflow-scroll border">
          <table class="min-w-full">
            <thead>
              <tr class="text-left bg-[#18469d] text whitespace-nowrap text-sm">
                <th class="px-6 py-3">S.No</th>
                <th class="px-6 py-3">Title</th>
                <th class="px-6 py-3">Year</th>
                <th class="px-6 py-3">Pdf</th>
                <th class="px-6 py-3">Command</th>
              </tr>
            </thead>
            <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
              <tr class="w-full">
                <td colspan="12" class="text-center py-6">
                  <div class="flex items-center justify-center">
                    <img src="@/assets/attendance/loading.gif" alt="" />
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <template v-if="syllabus_list.length > 0">
                <tr
                  v-for="(list, index) in syllabus_list"
                  :key="index"
                  class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
                >
                  <td class="px-6 py-3">
                    {{ (currentPage - 1) * perPage + index + 1 }}
                  </td>
                  <td class="px-6 py-3">{{ list.title }}</td>
                  <td class="px-6 py-3">
                    {{ list.years }}
                  </td>
                  <td class="px-6 py-3">
                    <a :href="list.pdf" target="_blank" class="text-blues">{{
                      list.pdf?.split("/")?.pop() || "-"
                    }}</a>
                  </td>
                  <td class="px-6 py-3">
                    <p class="break-words">{{ list.command }}</p>
                  </td>
                </tr>
              </template>
              <tr v-else>
                <td colspan="12" class="px-6 py-3 text-center">
                  No Data Found
                </td>
              </tr>
            </tbody>
            <!-- <tfoot>
            <tr>
              <td colspan="12" class="p-6 bg-[#18469d]"></td>
            </tr>
          </tfoot> -->
          </table>
        </div>
        <div
          v-if="syllabus_list.length > 0"
          class="flex justify-center py-4 space-x-2 p-6 bg-[#18469d]"
        >
          <button
            class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
            :disabled="currentPage === 1"
            @click="prevPage"
          >
            &laquo;
          </button>

          <button
            v-for="page in visiblePages"
            :key="page"
            class="px-3 py-2 rounded"
            :class="{
              'bg-white text-blues': currentPage === page,
              'bg-white border border-gray-400 text-gray-800':
                currentPage !== page,
            }"
            @click="changePage(page)"
          >
            {{ page }}
          </button>

          <button
            class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
            :disabled="currentPage >= totalPages"
            @click="nextPage"
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: true,
      syllabus_list: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 5,
      pageArray: [],
      perPage: 10,
      search_list: "",
      count_list: "",
      disable_submit: false,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["userInfo"]),
    visiblePages() {
      const start =
        Math.floor((this.currentPage - 1) / this.pageSize) * this.pageSize;
      const end = Math.min(start + this.pageSize, this.totalPages);
      return this.pageArray.slice(start, end);
    },
  },
  watch: {
    syllabus_list() {
      for (let i = 1; i < this.totalPages + 1; i++) {
        this.pageArray.push(i);
      }
    },
  },
  created() {
    this.getSyllabus(1);
  },
  methods: {
    async getSyllabus(page) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/syllabus-overall-list/?page=${page}&search=${this.search_list}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalPages = response.data.total_page;
            this.syllabus_list = response.data.data.data;
            this.count_list = response.data.total;
            this.loading = false;
            this.disable_submit = false;
          } else {
            console.log("got error");
            this.disable_submit = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getSyllabus(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getSyllabus(this.currentPage);
      }
    },

    changePage(page) {
      this.currentPage = page;
      this.getSyllabus(page);
    },
    async searchUserValue() {
      this.disable_submit = true;
      this.currentPage = 1;
      this.getSyllabus(1);
    },
  },
};
</script>

<style></style>
